module.exports = __webpack_public_path__ + "img/1-1.8c07ed21.png";